import { render, staticRenderFns } from "./MetricEditNumber.vue?vue&type=template&id=ec1b8380"
import script from "./MetricEditNumber.vue?vue&type=script&lang=js"
export * from "./MetricEditNumber.vue?vue&type=script&lang=js"
import style0 from "./MetricEditNumber.vue?vue&type=style&index=0&id=ec1b8380&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports